var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeFileAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.938,
    height: 17.25,
    viewBox: "0 0 12.938 17.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M7.547,4.582V0H.809A.807.807,0,0,0,0,.809V16.441a.807.807,0,0,0,.809.809h11.32a.807.807,0,0,0,.809-.809V5.391H8.356A.811.811,0,0,1,7.547,4.582ZM9.7,12.533a.405.405,0,0,1-.4.4H3.639a.405.405,0,0,1-.4-.4v-.27a.405.405,0,0,1,.4-.4H9.3a.405.405,0,0,1,.4.4Zm0-2.156a.405.405,0,0,1-.4.4H3.639a.405.405,0,0,1-.4-.4v-.27a.405.405,0,0,1,.4-.4H9.3a.405.405,0,0,1,.4.4Zm0-2.426v.27a.405.405,0,0,1-.4.4H3.639a.405.405,0,0,1-.4-.4v-.27a.405.405,0,0,1,.4-.4H9.3A.405.405,0,0,1,9.7,7.951Zm3.234-3.844v.206H8.625V0h.206A.808.808,0,0,1,9.4.236l3.3,3.3A.806.806,0,0,1,12.938,4.107Z",
    fill: "#bfbfbf"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeFileAlt);
export default __webpack_public_path__ + "static/media/Icon-awesome-file-alt.d1aac3bc86a302be575ae812f767ec74.svg";
export { ForwardRef as ReactComponent };